import { cn } from "@/lib/utils"

// BOOTH status marker — the STATIC half of the pair, same lozenge geometry as
// PulseDot (h-1.5 w-2, a capsule rather than a circle) with none of the motion.
//
// It exists because PulseDot always breathes, and most status markers in the
// product aren't live: a map legend swatch, an unread badge, a chart key, a
// "closed" state. Animating those made them read as events. So: PulseDot when
// something is happening right now, Lozenge when something simply IS.
//
// Between them they replace the hand-rolled `w-2 h-2 rounded-full bg-…` dots
// that had accumulated across the dashboards, maps, panels and marketing
// pages — which is why the shape kept drifting round.
//
// Colour comes in either way. Pass a `bg-*` class for a theme token
// (`bg-primary`, `bg-muted/50`) and the inline fill steps aside; pass `color`
// for a literal, which is what a chart key or a map pin needs when its value
// is computed. Setting both would be an inline style silently beating the
// class, so the class wins by construction rather than by luck.
export function Lozenge({ color = "#10b981", className }: { color?: string; className?: string }) {
  const hasBgClass = /(^|\s)bg-/.test(className ?? "")
  return (
    <span
      className={cn("inline-block h-1.5 w-2 flex-shrink-0 rounded-full align-middle", className)}
      style={hasBgClass ? undefined : { backgroundColor: color }}
      aria-hidden="true"
    />
  )
}
